module.exports = __webpack_public_path__ + "img/H-B-123456-load-standup-base.51779dd0.png";